





/**
 * A component displaying the stage images.
 * It provides the browser with the given (via data) image sources and uses native functionality to choose the right one.
 */
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import GenericImageGenerator from '@owc-utils/GenericImage/GenericImageGenerator';
import GenericImage from '@owc-packages/GenericImage/src/GenericImage.vue';

export default ComponentInitializeDispatcher.extend({
  name: 'owc-stage-image',
  components: {
    GenericImage,
  },
  props: {
    imageData: {
      type: Object,
    },
    sizes: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    stageImage(): GenericImageGenerator | null {
      const payload = this.imageData?.stageImage;
      if (payload && !payload.isGenerated) {
        return new GenericImageGenerator(payload, []);
      } else if (payload) {
        return payload;
      }

      return null;
    },
  },
});
